var React = require('react');

function ExclamationSolid (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#005F9E","fillRule":"nonzero","strokeWidth":"0"},[React.createElement("path",{"d":"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z","key":0}),React.createElement("path",{"d":"M12.96 13.448V5.672h-1.92v7.776h1.92zM12 17.096c.352 0 .653-.123.904-.368.25-.245.376-.539.376-.88 0-.341-.128-.63-.384-.864a1.284 1.284 0 0 0-.896-.352c-.352 0-.653.123-.904.368-.25.245-.376.539-.376.88 0 .17.035.33.104.48.07.15.163.277.28.384.117.107.253.192.408.256.155.064.317.096.488.096z","key":1})]));
}

ExclamationSolid.displayName = "ExclamationSolid";

ExclamationSolid.defaultProps = {"width":"16","height":"16","viewBox":"0 0 28 28"};

module.exports = ExclamationSolid;

ExclamationSolid.default = ExclamationSolid;
